import { render } from "./OrderItemsTableEntry.vue?vue&type=template&id=e5380dc2"
import script from "./OrderItemsTableEntry.vue?vue&type=script&lang=js"
export * from "./OrderItemsTableEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__